
const je = require('json-encrypt')
let user_permissions = window.localStorage.getItem("user_permissions");
user_permissions = JSON.parse(JSON.parse(je.decrypt(user_permissions)));

var modules = [{
  _name: 'CSidebarNavItem',
  name: 'Inicio',
  to: '/inicio/inicio',
  icon: 'cilHome',
}];

if(user_permissions.indexOf('ProductList') > -1){
// {
//   _name: 'CSidebarNavDropdown',
//   name: 'Entidad',
//   route: '/cliente',
//   icon: 'cil-puzzle',
//   items: [
//     {
//       name: 'Cliente',
//       to: '/cliente/listar'
//     },
//     {
//       name: 'Proveedor',
//       to: '/proveedor/listar'
//     },
//   ]
// },
}

if(user_permissions.indexOf('ProductList') > -1 || user_permissions.indexOf('CategoryList') > -1 ){
  let me = this;
  let item = [];
  if (user_permissions.indexOf('ProductList') > -1) {
    item.push({ name: 'Productos', to: '/producto/listar' });
    
  }
  if (user_permissions.indexOf('CategoryList') > -1) {
    item.push({ name: 'Categorias', to: '/categoria/listar'});
  }

  let TypeUser = {
    _name: 'CSidebarNavDropdown',
    name: 'Productos',
    icon: 'cil-applications',
    items: item
  }
  modules.push(TypeUser);
}


if(user_permissions.indexOf('ClientList') > -1 || user_permissions.indexOf('ProviderList') > -1 ){
  let me = this;
  let item = [];
  if (user_permissions.indexOf('ClientList') > -1) {
    item.push({ name: 'Clientes', to: '/cliente/listar' });
    
  }
  if (user_permissions.indexOf('CategoryList') > -1) {
    item.push({ name: 'Proveedores', to: '/proveedor/listar'});
  }

  let TypeUser = {
    _name: 'CSidebarNavDropdown',
    name: 'Entidades',
    icon: 'cil-applications',
    items: item
  }
  modules.push(TypeUser);
}


if(user_permissions.indexOf('RoomList') > -1 || user_permissions.indexOf('TypeRoomList') > -1 ){
  let me = this;
  let item = [];
  if (user_permissions.indexOf('RoomList') > -1) {
    item.push({ name: 'Habitaciones', to: '/habitacion/listar' });
    
  }
  if (user_permissions.indexOf('TypeRoomList') > -1) {
    item.push({ name: 'Tipo de Habitaciones', to: '/tipo-habitacion/listar'});
  }

  let TypeUser = {
    _name: 'CSidebarNavDropdown',
    name: 'Habitaciones',
    icon: 'cil-applications',
    items: item
  }
  modules.push(TypeUser);
}

if(user_permissions.indexOf('ShoppingList') > -1 ){
  let me = this;

  let TypeUser = {
    _name: 'CSidebarNavItem',
    name: 'Compra',
    to: '/compra/listar',
    icon: 'cilHome',
  }
  modules.push(TypeUser);
}


if(user_permissions.indexOf('RoomControlList') > -1 ){
  let me = this;

  let TypeUser = {
    _name: 'CSidebarNavItem',
    name: 'Control Habitación',
    to: '/control-habitacion/listar',
    icon: 'cilHome',
  }
  modules.push(TypeUser);
}





if(user_permissions.indexOf('UserList') > -1 || user_permissions.indexOf('UserTypeList') > -1  || user_permissions.indexOf('VoucherpeList') > -1 || user_permissions.indexOf('Business') > -1){
  let me = this;
  let item = [];
  if (user_permissions.indexOf('UserList') > -1) {
    item.push({ name: 'Usuario', to: '/usuario/listar' });
    
  }
  if (user_permissions.indexOf('UserTypeList') > -1) {
    item.push({ name: 'Tipo de Usuario', to: '/tipo-usuario/listar'});
  }
  if (user_permissions.indexOf('VoucherList') > -1) {
    item.push({ name: 'Comprobante',to: '/comprobante/listar'});
  }
  if (user_permissions.indexOf('BusinessList') > -1) {
    item.push({name: 'empresa',to: '/empresa/listar'});
  }
  let TypeUser = {
    _name: 'CSidebarNavDropdown',
    name: 'Mantenimiento',
    icon: 'cil-applications',
    items: item
  }
  modules.push(TypeUser);
}



export default [
  {
    _name: 'CSidebarNav',
    _children: modules
  }
]